import type { Permission} from "./permission";
import { permissions } from "./permission";
import type { Scope } from "./scope";

/**
 * Generates scopes for resource path segments and permissions
 */
function scopeFactory(
    segments: string | string[],
    withPermission?: undefined
): Scope[];
function scopeFactory(
    segments: string | string[],
    withPermission: Permission
): Scope;
function scopeFactory(
    segments: string | string[],
    withPermission: Permission[]
): Scope[];
function scopeFactory(
    segments: string | string[],
    withPermission: Permission | Permission[]
): Scope | Scope[];
function scopeFactory(
    segments: string | string[],
    withPermission?: Permission | Permission[]
): Scope | Scope[];
function scopeFactory(
    segments: string | string[],
    withPermission?: Permission | Permission[]
): Scope | Scope[] {
    if (!segments || !segments.length) return [];
    const resourcePath = Array.isArray(segments)
        ? segments.join(":")
        : segments;
    if (!withPermission || !withPermission.length) {
        return permissions.map(permission => `${resourcePath}:${permission}`);
    }
    if (Array.isArray(withPermission)) {
        return withPermission.map(
            permission => `${resourcePath}:${permission}`
        );
    }

    return `${resourcePath}:${withPermission}`;
}
export { scopeFactory };
